import React from "react";
import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";

export default function NotFound({ 
  message = "Oops! Data not found.", 
  linkText = "Go Back Home", 
  linkTo = "/" 
}) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center w-full text-center px-4">
      <div className="bg-red-50 p-4 rounded-full mb-4">
        <AlertCircle className="w-10 h-10 text-red-500" />
      </div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">{message}</h2>
      <p className="text-gray-500 mb-6 max-w-md">
        The page or resource you are looking for might have been removed or is temporarily unavailable.
      </p>
      <Link 
        to={linkTo} 
        className="px-6 py-2.5 bg-gray-900 text-white rounded-lg font-medium hover:bg-black transition shadow-lg transform hover:-translate-y-0.5"
      >
        {linkText}
      </Link>
    </div>
  );
}